<template>
    <div>
      <p class="ArticleNormal">
        对一座城市体系化评估的指标，向来是城市发展的重要抓手。无论是官方机构还是商业机构，每年都会出品各类城市榜单，试图从多角度评价一座城市的发展状态与繁荣活力，以期指导各大城市把握发展机遇。同时，城市本身也会投入巨大精力进行“城市体检”等工作，以了解自身的优势及短板。
      </p>
      <p class="ArticleNormal">
        然而，着眼于线下基础设施与GDP等发展指标城市评估模型，已无法满足新形势的需要，亟待引入更广泛的评价纬度：一方面增加更多实时化、精细化的数据来源，另一方面引入“人”的体验与对于城市评价的主观视角，做到真正“以人为本”去衡量一座城市是否美好。
      </p>
      <img src="../../../assets/1st/Articles/Article_4/contant_9.jpg"/>
      <p class="ArticleNormal">
        巨量引擎联合中国城市规划设计研究院发布的《美好城市指数：短视频与城市繁荣关系白皮书》，推出了基于抖音大数据的城市线上繁荣度评估模型SIRFA，从传播度(Spreading）、影响度（Influence)、推荐度(Recommendation)、好感度(Favorability)、吸引度(Atrraction)五个维度评估城市线上繁荣度。
      </p>
      <img src="../../../assets/1st/Articles/Article_4/contant_1.jpg"/>
      <p class="ArticleNormal">
        其中，传播度通过评估视频播放量、播放时长、完播率，反映出城市内容的传播广度。影响度代表城市视频的发布数量。推荐度反映出一万粉丝以上的达人创作者在城市视频互动方面的作用。好感度反映了普通用户创作的城市视频受欢迎程度。吸引度则通过衡量企业账号入驻数量及POI视频数量，映射一座城市吸引力的大小。五个维度互为依托、有机融合，通过反映抖音用户对城市的线上关注与互动行为，为美好城市引入人本视角的丰富数据源。
      </p>
      <p class="ArticleNormal">
        将SIRFA模型作为互联网语境中衡量城市发展的新标尺，城市将得以知悉线上繁荣城市打造逻辑，拆解自身增长策略，从而获得具体化、综合性的长效发展指南。
      </p>
      <p class="ArticleHead">
        五大核心维度  SIRFA“重绘”城市线上画像
      </p>
      <p class="ArticleNormal">
        SIRFA模型，是基于抖音POI视频数据构建的五维模型。POI (point of interest) 也即“兴趣点”，地理信息系统中泛指一切可以抽象为点的地理对象，尤其是与人们生活密切相关的地理实体。在抖音平台，越来越多的创作者习惯将自己创作的视频带上POI地理位置兴趣点进行发布。据巨量算数统计，2019年7月-2020年6月抖音用户累计发布超过10亿条城市POI视频，全年播放量超过37000亿，这使得抖音能够通过“数字孪生”映射出城市的空间形象。每个用户都可以看做一个分布在城市中的可移动的传感器，通过线下打卡现实中的物理城市、线上传播数字城市，呈现出短视频平台上动态的数字孪生城市。
      </p>
      <p class="ArticleNormal">
        随着POI视频播放量的增加，这些短视频也对POI背后的城市坐标起到了有效的推广作用。因此，POI兴趣点的数量及其对应的POI视频数量、播放量等各类指标，能够相对精确地反映一座城市乃至一个区域的发展情况，进而映射出城市的线上繁荣程度。
      </p>
      <p class="ArticleNormal">
        按照城市POI视频在线上呈现的传播状态进行划分，SIRFA模型将衡量一座城市的数据指标分为以上五个核心维度。
      </p>
      <p class="ArticleNormal">
        当前，SIRFA模型对我国大陆下辖的31个省级行政区进行评估，覆盖660多个市级城市单位、2000多个县区级城市单位。模型同时选取了能够代表城市发展水平与繁荣程度的景区、商业综合体、民宿酒店、特色美食、文化场馆五大模块进行综合评估。通过动态化评价体系与小至景区、商圈的精细化评价指标，助力城市制定立体化发展策略。基于SIRFA模型五个指标得分输出的城市五维雷达图，能够实现城市线上数据可视化、可分析化，精准反映出城市的线上传播痛点。通过对繁荣度差异背后成因的分析，为城市指明线上品牌营销方向。
      </p>
      <img src="../../../assets/1st/Articles/Article_4/contant_2.jpg"/>
      <p class="ArticleHead">
        SIRFA模型 透视城市线上繁荣痛点
      </p>
      <p class="ArticleNormal">
        《美好城市指数白皮书》引入了中国城市规划设计研究院于2019年发布的《中国城市繁荣活力评估报告2019》数据，其对城市线下发展的评价指标进行了细致的划分，将国内108个重点城市按繁荣活力状况聚合为5种类型，分别为繁荣A型、繁荣B型、活力A型、活力B型和活力C型。通过对城市线上热度与线下发展的分类或排名进行对比，抖音短视频数据与城市实体空间的发展程度呈现出“数字孪生”关系，且为城市繁荣构建指明了方向。
      </p>
      <p class="ArticleNormal">
        在城市特征上，繁荣A型城市呈现出多元化的高活力水平。将其与城市线上繁荣指数（SIRFA）模型进行交叉验证，可以发现城市物质空间和社会治理发展较好的城市，也是线上热度很高的城市。线上繁荣度排名前十位的城市中，除北上广深这样的超一线的明星城市，也有近年来发展势头迅猛的成都、重庆、杭州和东莞这样的新一线“后起之秀”。以成都为例，作为线下繁荣A型城市中的网红城市，6月成都城市线上繁荣度得分为4865分，高于新一线城市平均分2127分一倍有余。
      </p>
      <p class="ArticleNormal">
        对线上线下数据交叉对比进一步观察，可发现部分线下发展较好的城市需要线上策略化传播。以珠海为例，作为繁荣A型城市其线下发展水平是非常好的，例如在功能混合使用方面，珠海的特色文化场所密集区占建成区面积比为7.5%，基本公共服务设施覆盖率（完整社区比重）85%左右，在该维度的整体排名仅次于广州，位于第2位。然而珠海线上繁荣度仅排名全国第64位，线上的热度不佳直接导致珠海在吸引旅游人口方面竞争力较弱，对国内旅游人口的吸引排名为37。珠海如果能需进一步优化以短视频为代表的新媒体传播策略，打造宜居宜游的新时期城市文旅形象，结合线下得天独厚的旅游资源优势和服务能力，一定会得到更好的发展。
      </p>
      <img src="../../../assets/1st/Articles/Article_4/contant_3.jpg"/>
      <p class="ArticleNormal">
        此外，对于线下发展尚有提升空间的城市来说，数据对比显示其线上热度同样需要综合提升。例如，郑州和济南都是线下繁荣B型城市，整体上活力水平低于繁荣A型。郑州在城市发展来看其年轻人口比重较大，小微企业密度、公共设施覆盖程度、夜间活力高，创新空间更多，商业设施更多。再加上线上的宣传推广投入力度较大，整个城市的线上话题度较高与城市发展程度较好是相匹配的。相比之下济南想要获得更好的城市发展则需要在线下的城市建设和线上的品牌塑造层面共同发力。
      </p>
      <img src="../../../assets/1st/Articles/Article_4/contant_4.jpg"/>
      <p class="ArticleNormal">
        在济南线下的城市空间发展方面，可通过科学合理地设置街区单元的控制与引导指标提升城市的服务水平和空间活力：例如城市整体人口密度建议在1.2-1.6万人/平方公里，公交覆盖率应达到70-85%以上，公园绿地覆盖率应达到80-90%以上；针对大型商业街区（含商务区）的路网密度集中适宜在10-12km/km²之间，开发强度设置容积率集中在1.8-2.0之间，建筑密度集中在40%以上。通过精细化的规划设计优化空间结构和空间质量，并运用景观与装置提升空间颜值，以打造美好的城市形象。
      </p>
      <p class="ArticleNormal">
        在济南线上城市形象传播方面，可以利用短视频等新媒体的优势，着力挖掘济南市的城市文化特色和适合传播的符号，结合城市线上繁荣指数（SIRFA）模型，在济南市的推荐度、好感度和吸引度上实现提升。例如推荐度的提升，可以与达人合作推广济南的特色美食或文化活动等内容，甚至培育出济南当地的特色达人，与济南城市形象共同成长；在好感度方面，结合线上用户的浏览兴趣，对城市的风景、特色建筑、当地美食、文化活动等进行挖掘，通过创意形式呈现城市特色；吸引度方面。加入城市官方的宣传力量，为济南的商业服务与文旅服务质量进行背书，吸引更多企业加入传播矩阵，共建繁荣活力的美好城市。
      </p>
      <img src="../../../assets/1st/Articles/Article_4/contant_5.jpg"/>
      <p class="ArticleHead">
        三大方向  SIRFA定制城市线上传播策略
      </p>
      <p class="ArticleNormal">
        结合上述观点，SIRFA模型可以直观反映城市内容在短视频生态中的传播链路，并辅助城市分析传播链路中具体环节的缺漏，从而明确未来传播发力点。在各个城市硬实力短期内相对恒定的前提下，城市借助SIRFA模型可以实现立足线上的软实力提升。
      </p>
      <p class="ArticleNormal">
        结合城市之间的定位差异，处于不同发展水平的城市，可结合SIRFA模型定向择取三大线上传播思路之一。
      </p>
      <p class="ArticleNormal">
        <span class="ArticleBolder">&middot;&nbsp;对于线下具备既有优势，且线上化繁荣度较高的城市，需不断挖掘新的传播特色。</span>
      </p>
      <p class="ArticleNormal">
        以北京上海为代表的一线城市为例，基于线下建设状况的领先，城市在线上也具备天然的庞大传播量，差异性的创新内容则是新的突围点。例如，在抖音高播放量的短视频中，可以看到游览北京故宫的小众观光路线，通过这样的方式，为用户耳熟能详的北京传统地标注入了全新味道；再如抖音中上海M豆巧克力世界的用户打卡、创作量巨大，通过从0到1打造新晋网红名片，也能为繁荣城市进一步增添线上竞争力。
      </p>
      <img src="../../../assets/1st/Articles/Article_4/contant_6.jpg"/>
      <p class="ArticleNormal">
        <span class="ArticleBolder">&middot;&nbsp;对于线下基础设施较好，但线上发展尚未与线下协同的城市，需找到传播定位，并结合SIRFA模型寻找对标城市，定向提升从而实现线上线下发展程度的匹配。</span>
      </p>
      <p class="ArticleNormal">
        例如，厦门作为线下繁荣A型城市，在SIRFA模型评估出的城市线上繁荣度榜单中排名30+，与线下实体空间优势呈现一定差异。未来厦门可围绕其独特文旅资源优势，发掘鼓浪屿等大众景点的时尚特色玩法，对标线上热门旅游城市如西安重庆，进一步优化以短视频为代表的新媒体传播策略，打造宜居宜游的新时期城市文旅形象。
      </p>
      <img src="../../../assets/1st/Articles/Article_4/contant_7.jpg"/>
      <p class="ArticleNormal">
        <span class="ArticleBolder">&middot;&nbsp;对于线下发展竞争力较低的城市，需要发掘城市的独有特质并进行放大，继而反哺线下，对城市整体发展起到推动作用。</span>
      </p>
      <p class="ArticleNormal">
        以西北地区的城市为例，西宁凭借昆仑立交桥、园树立交桥等多个地标在抖音吸引大量用户观看，通过航拍、倍速等二次创作技巧，更是放大了“立交桥”这一城市特色，有效加深着用户对西宁的繁荣城市印象；同样作为西北部城市的伊犁，则在抖音打出了红柳烤肉这一出圈美食。可见，无论是放大城市硬实力，还是挖掘城市软文化，腰尾部城市可从多个方面寻找到未来发力方向。
      </p>
      <img src="../../../assets/1st/Articles/Article_4/contant_8.jpg"/>
      <p class="ArticleNormal">
        城市政务侧可以围绕以上三种思路，结合SIRFA模型精细制定城市线上传播策略，同时，城市各个模块的相关品牌，也可以运用SIRFA模型，看到自身在种草、转化、附加服务等方面的短板，定向促进个体品牌或品牌集群的长效发展。
      </p>
      <p class="ArticleNormal">
        得当的城市营销策略，能够为城市发展带来综合而延续的推动力，不仅能刺激文旅等消费需求，提升人口与人才的吸纳度，也能够促进城市产业和经济的加速发展，从而将城市综合实力整合起来，实现经济与文化的更大突破。
      </p>
      <p class="ArticleNormal">
        SIRFA模型的出现，为衡量美好城市的繁荣活力引入了实时化的数据源与全新视角，构建出以人为中心的城市评价体系。通过对城市在短视频生态中传播链路的诊断分析，帮助城市有针对性地制定品牌营销策略，最终实现城市线上形象传播和本土地域文化的融合共生，展现出具备独特竞争力与时代魅力的鲜明城市形象。SIRFA模型作为城市营销数字化趋势下的重要风向标，将为广大城市开辟出搭乘新媒体浪潮而起的新思路。
      </p>
    </div>
</template>

<script>
    export default {
        name: "Article4"
    }
</script>

<style scoped>
  img{
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/1st/Articles/Article4.vue